import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { getSignalsFromGroupedSignals } from "app/pages/sales-intelligence/domain/signals/utils/signal-ids";
import { listsQueryKeys } from "app/pages/sales-intelligence/modules/lists/sub-modules/my-list/services/queries/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { saveNewSearchAsync } from "app/pages/sales-intelligence/sub-modules/advanced-search/store/action-creators";
import type { NewSearchDto, SavedSearchDto } from "app/pages/sales-intelligence/sub-modules/advanced-search/types/dto";
import { signalsUpsertedAction } from "app/pages/sales-intelligence/sub-modules/signals/store/action-creators";

export const useCreateSavedSearchMutation = () => {
    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (dto: NewSearchDto): Promise<SavedSearchDto> => {
            return salesApiService.leadsSearch.savedSearches.saveNewSearch(dto);
        },
        onSuccess: (data) => {
            dispatch(saveNewSearchAsync.success(data));

            const signals = getSignalsFromGroupedSignals(data.queryFilters.signalsFilters ?? {});

            if (signals.length > 0) {
                dispatch(signalsUpsertedAction(signals));
            }

            void queryClient.invalidateQueries({ queryKey: listsQueryKeys.savedSearches("") });
        },
    });
};
